import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import "./topDashboard.scss";
import { GiBookCover } from "react-icons/gi";
import { FaCartShopping } from "react-icons/fa6";
import { FaUser } from "react-icons/fa";

const TopDashboard = () => {
  const [products, setProducts] = useState({});
  const [customer, setCustomer] = useState({});

  useEffect(() => {
    const getData = async () => {
      try {
        const response = await axios.get("/get-all-product-number");
        setProducts(response.data)
      } catch (error) {
        return;
      }
    };
    getData();
  }, []);

  useEffect(() => {
    const getData = async () => {
      try {
        const response = await axios.get("/get-all-customers-number");
        setCustomer(response.data);
      } catch (error) {
        return;
      }
    };
    getData();
  }, []);

  const totalProduct = products.length;
  const totalCustomer = customer.length;




  return (
    <div className="h_profile_head">
      <div className="h_hed_sec a">
        <span>
          <h4 style={{ color: "rgba(82, 67, 217" }}>{totalProduct}</h4>
          <small>Total Products</small>
        </span>
        <span>
          <div className="h_i_in aa">
            <FaCartShopping size={17} />
          </div>
        </span>
      </div>
      <div className="h_hed_sec b">
        <span>
          <h4 style={{ color: "rgba(247, 193, 46)" }}>{totalCustomer}</h4>
          <small>Total Customer</small>
        </span>
        <span>
          <div className="h_i_in bb ">
            <FaUser size={17} />
          </div>
        </span>
      </div>{" "}
      {/* <div className="h_hed_sec c">
        <span>
          <h4>200</h4>
          <p>Total Product</p>
        </span>
        <span>
          <div className="h_i_in cc">
            <FaMoneyBillTrendUp size={17} />
          </div>
        </span>
      </div>
      <div className="h_hed_sec d">
        <span>
          <h4>100</h4>
          <p>Total Brand</p>
        </span>
        <span>
          <div className="h_i_in dd">
            <FaMoneyBillTrendUp size={17} />
          </div>
        </span>
      </div> */}
    </div>
  );
};

export default TopDashboard;
